import { motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import { waLink } from "@/lib/site";

export const EASE = [0.22, 1, 0.36, 1];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70, duration: 1.6 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const useGoTo = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (id) => (pathname === "/" ? scrollToId(id) : navigate(`/#${id}`));
};

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 1.1, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light }) => (
  <span className={`font-mono-x text-xs uppercase tracking-[0.3em] flex items-center gap-3 ${light ? "text-[#8A6A2E]" : "text-[#C9A55C]"}`}>
    <span className={`h-px w-10 ${light ? "bg-[#8A6A2E]" : "bg-[#C9A55C]"}`} />
    {children}
  </span>
);

export const WhatsIcon = ({ className = "w-5 h-5" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.07c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35zM12.05 21.8h-.01a9.87 9.87 0 0 1-5.03-1.38l-.36-.21-3.74.98 1-3.65-.24-.37a9.86 9.86 0 0 1-1.51-5.26c0-5.45 4.44-9.88 9.89-9.88 2.64 0 5.12 1.03 6.99 2.9a9.82 9.82 0 0 1 2.89 6.99c0 5.45-4.44 9.88-9.88 9.88zm8.41-18.29A11.82 11.82 0 0 0 12.05 0C5.5 0 .16 5.34.16 11.89c0 2.1.55 4.14 1.59 5.94L.06 24l6.3-1.65a11.88 11.88 0 0 0 5.68 1.45h.01c6.55 0 11.89-5.34 11.89-11.89 0-3.18-1.24-6.17-3.48-8.4z" />
  </svg>
);

export const WaButton = ({ topic, label = "Ofertë në WhatsApp", testId, className = "" }) => (
  <a
    href={waLink(topic)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    className={`btn-gold group inline-flex items-center gap-3 rounded-full px-7 py-4 text-sm font-semibold tracking-wide ${className}`}
  >
    <WhatsIcon className="w-5 h-5" />
    <span>{label}</span>
  </a>
);
